const BrushIcon = ({ ..._props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9967 2.08384L21.9971 2.08385C22.3972 2.08837 22.7714 2.24574 23.0547 2.52866C23.3429 2.81738 23.5 3.19757 23.5 3.60424C23.5 3.99768 23.3509 4.36954 23.0789 4.65421C23.0789 4.65425 23.0789 4.65429 23.0788 4.65432L12.8948 15.3051C12.8232 15.1569 12.7449 15.0113 12.6601 14.8688L12.6601 14.8688C12.0764 13.8876 11.2431 13.1453 10.2582 12.7088L20.9295 2.50512C20.9295 2.50509 20.9295 2.50507 20.9295 2.50504C21.2149 2.23231 21.586 2.08374 21.9795 2.08374L21.9967 2.08384ZM8.25649 14.672L8.25665 14.672C9.37922 14.7189 10.2357 15.3779 10.7012 16.296C11.1707 17.222 11.2234 18.3805 10.7438 19.3593L11.1928 19.5793L10.7438 19.3593C9.86033 21.1626 7.64504 21.9163 5.62617 21.9163C5.5629 21.9163 5.5002 21.9156 5.43788 21.9141L5.43783 21.9141C4.57164 21.8933 3.47144 21.6888 2.50867 21.2577C1.73834 20.9128 1.10072 20.4441 0.714288 19.8503C1.8668 19.4756 3.04456 18.9066 3.86319 17.857L3.46894 17.5495L3.8632 17.857C4.10069 17.5525 4.31525 17.2187 4.51071 16.9145C4.60426 16.769 4.69343 16.6302 4.77865 16.5048C5.058 16.0935 5.34327 15.7422 5.73785 15.4583C6.42926 14.9609 7.27107 14.6688 8.10759 14.6688C8.15733 14.6688 8.20697 14.6699 8.25649 14.672Z"
        fill="#090914"
        stroke="#090914"
      />
    </svg>
  );
};

export default BrushIcon;
